import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {QR_CODE_PATTERN} from "../constants/validation.constants";

export const qrCodeGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const qrCode = route.paramMap.get('qrCode');

  if (qrCode && QR_CODE_PATTERN.test(qrCode)) {
    return true;
  }
  router.navigate(['/error-page']);
  return false;
};
